/**
 * @file Pure view component for section separator in notes list
 * @module features/notes/components/SectionSeparator/SectionSeparatorView
 * @description
 * Provides consistent vertical spacing between sections in section lists.
 * Used as SectionSeparatorComponent in SectionList and BottomSheetSectionList.
 */

import { memo, ReactElement } from "react";

import { Box } from "@/components/atoms/Box";

/**
 * Pure view component for section separator
 * @returns Separator element with 8px height (h-2)
 */
const SectionSeparatorView = (): ReactElement => <Box className="h-2" />;

SectionSeparatorView.displayName = "SectionSeparatorView";

export default memo(SectionSeparatorView);
